import React from 'react'

// export class InvoiceAfterTaxTotal extends React.Component {
//   render() {
//
//         let total = 0.00, totalTax=0.00, totalDiscount=0.00
//
//         let totalBeforeDiscount = 0.00
//
//         if(typeof this.props.invoice !=="undefined") {
//           let invoice = this.props.invoice
//
//           if(this.props.is_composition) {
//
//             totalBeforeDiscount = parseFloat(parseFloat(invoice.totalPrice)).toFixed(2)
//             totalDiscount = invoice.totalDiscount
//             total = invoice.total
//
//
//             return (<table className="table">
//                           <tbody>
//                           <tr><td>Sub Total</td><td>&nbsp;{totalBeforeDiscount}</td></tr>
//                           <tr><td>Discount</td><td>-{totalDiscount}</td></tr>
//                           <tr><td>Total</td><td>&nbsp;{total}</td></tr>
//                           </tbody>
//                         </table>)
//
//           }
//           else {
//
//             totalBeforeDiscount = parseFloat(parseFloat(invoice.totalPrice)).toFixed(2)
//             totalDiscount = invoice.totalDiscount
//             totalTax = invoice.totalTax
//             total = invoice.total
//
//             return (<table className="table">
//                           <tbody>
//                           <tr><td>Sub Total</td><td>&nbsp;{totalBeforeDiscount}</td></tr>
//                           <tr><td>GST </td><td>&nbsp;{totalTax}</td></tr>
//                           <tr><td>Discount</td><td>-{totalDiscount}</td></tr>
//                           <tr><td>Total</td><td>&nbsp;{total}</td></tr>
//                           </tbody>
//                         </table>)
//
//           }
//         }
//   }
// }


export default class InvoiceTotal extends React.Component {

  render() {


    let total = 0.00, cessRow, totalTax=0.00, totalDiscount=0.00

    let totalBeforeDiscount = 0.00


    if(typeof this.props.invoice !=="undefined") {
      let invoice = this.props.invoice

      if(this.props.is_composition) {

        totalBeforeDiscount = parseFloat(parseFloat(invoice.totalPrice) + parseFloat(invoice.totalDiscount)).toFixed(2)
        totalDiscount = invoice.totalDiscount
        total = invoice.total

        return (<table className="table">
                      <tbody>
                      <tr><td>Sub Total</td><td>&nbsp;{totalBeforeDiscount}</td></tr>
                      <tr><td>Discount</td><td>-{totalDiscount}</td></tr>
                      <tr><td>Total</td><td>&nbsp;{total}</td></tr>
                      </tbody>
                    </table>)

      }
      else {

        if(invoice.add_cess) {
          cessRow = <tr><td>Cess </td><td>&nbsp;{invoice.totalCess}</td></tr>
        }
        totalBeforeDiscount = parseFloat(parseFloat(invoice.totalPrice) + parseFloat(invoice.totalDiscount)).toFixed(2)
        totalDiscount = invoice.totalDiscount
        totalTax = invoice.totalTax
        total = invoice.total

        return (<table className="table">
                      <tbody>
                      <tr><td>Sub Total</td><td>&nbsp;{totalBeforeDiscount}</td></tr>
                      <tr><td>Discount</td><td>-{totalDiscount}</td></tr>
                      <tr><td>GST </td><td>&nbsp;{totalTax}</td></tr>
                      {cessRow}
                      <tr className="success"><td><strong>Total</strong></td><td><strong>&nbsp;{total}</strong></td></tr>
                      </tbody>
                    </table>)

      }

    }




  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/rowelements/invoicetotal.js